<template>
    <div>
        <button
            :disabled="disabled"
            type="submit"
            class="button button--primary button--full-width"
            @click="verifyToken"
        >
            <LoadingIndicator v-if="loading" />
            <template v-else>
                {{ label }}
            </template>
        </button>
        <i18n class="recaptcha-privacy-policy" path="recaptcha.privacy_policy" tag="p">
            <template #privacy_policy_link>
                <a href="https://policies.google.com/privacy">{{ $t('recaptcha.privacy_policy_link') }}</a>
            </template>
            <template #terms_of_service_link>
                <a href="https://policies.google.com/terms">{{ $t('recaptcha.terms_of_service_link') }}</a>
            </template>
        </i18n>
    </div>
</template>

<script>
import LoadingIndicator from '~/components/LoadingIndicator';
import recaptchaMixin from '~/mixins/recaptchaMixin';

export default {
    name: 'RecaptchaButton',
    components: { LoadingIndicator },
    mixins: [recaptchaMixin],
    props: {
        loading: {
            type: Boolean,
            default: false,
        },
        isInvalid: {
            type: Boolean,
            default: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        label: {
            type: String,
            required: true,
        },
        recaptchaAction: {
            type: String,
            required: true,
        },
    },
    methods: {
        verifyToken() {
            this.$emit('start-verifying');

            this.$nextTick(async () => {
                if (this.isInvalid) {
                    this.$emit('error');

                    return;
                }

                if (!this.$config.recaptcha.enabled) {
                    this.$emit('success', null);

                    return;
                }

                try {
                    const token = await this.$recaptcha.execute(this.recaptchaAction);
                    this.$emit('success', token);
                } catch (error) {
                    this.$emit('error');
                    this.$sentry.captureException(error);
                }
            });
        },
    },
};
</script>

<style lang="scss">
@import '~/sass/_variables.scss';

.recaptcha-privacy-policy {
    font-size: 12px;
    line-height: normal;
    color: $neutral-60;
    margin-top: 10px;
}
</style>
